import { RebrandHelper } from "../helpers/brand/RebrandHelper";

export const UrlComponents = {
  DomainPartial: {
    HOL: ".health-on-line.",
    HOLCustom: "-hol.z-ppp"
  }
//   HOL: "localhost",

// HOLCustom: "localhost"
//   }
};
export const AllowableTransversalOrigins = [
  "https://axapppcscol-stg.metafaq.com",
  "https://axapppcscol.metafaq.com",
  "https://uktvl.axappphealthcare.co.uk",
  "https://uk.axahealth.co.uk",
  "https://inttvl.axappphealthcare.co.uk",
  "https://staging-holtvl.health-on-line.local",
  "https://holtvl.health-on-line.co.uk"
];
export const EPDomains = {
  Dev :"https://engage-web-dv.onlineapps.dv.axahealth.co.uk",
  QA:"https://engage-web-qa.onlineapps.dv.axahealth.co.uk",
  PP:"https://engage-web-pp.axahealth.co.uk",
  Prod:"https://engage.axahealth.co.uk",
  DR:"https://engage-web-dr.z-ppp-pp-ase01.xpzcloud.com"
};

export const Domains = {
  AxaDomain: RebrandHelper.getAxaDomain(),
  HOLDomain: "https://www.health-on-line.co.uk",
  AGHDomain: "https://www.axaglobalhealthcare.com",
  PHGDomain: "https://gateway.axahealth.co.uk",
  APlusDomain: "https://www.axaactiveplus.co.uk"
};

export const Urls = {
  MOL: {
    Prod: "https://apps.axahealth.co.uk/os/"
  },
  PrivacyUrl: {
    HOL: `${Domains.HOLDomain}/site-services/privacy-legal-cookies`,
    MOL: "https://www.axa.co.uk/privacy-policy/",
    Marketing: "https://www.axa.co.uk/privacy-policy/marketing/",
    International: `${Domains.AGHDomain}/privacy-and-legal`
  },
  CookiePolicyUrl: {
    MOL: `${Domains.AxaDomain}/cookie-policy/`,
    HOL: `${Domains.HOLDomain}/cookie-policy/`
  },
  AxaBookappointmentUrl:"https://member.doctorcareanywhere.com/Account/Login/axa",
  AXACookiePrivacyUrl: `${Domains.AxaDomain}/footer/cookie-policy/`,
  AxaPppPrivacyUrl: "https://www.axa.co.uk/privacy-policy",
  AccessibilityUrl: `${Domains.AxaDomain}/accessibility/`,
  AxaHealthAboutUrl: "https://www.axahealth.co.uk/aboutaxahealth",
  AxaHealthAboutUs: "https://www.axahealth.co.uk/about-us",
  AxaHealthLegal: "https://www.axahealth.co.uk/legal-information/",
  AxaHealthHolAbout: "https://www.axahealth.co.uk/hol-about-axa-health",
  AxaHealthUnderwritingTerms:
    "https://www.axahealth.co.uk/globalassets/sme/pdfs/underwriting-docs/pb102533-sme-underwriting-terms-explained.pdf",
  AxaPrivateHealthCareGuide: "https://www.axahealth.co.uk/newasset/sme/pdfs/about-your-private-healthcare-benefit.pdf",
  AxaMakeAnAppointmentButton : "https://app.virtuallucyweb.co.uk/login/?source_url=mol-msk",

  AxaPppFacebook: "https://www.facebook.com/AXAPPP",
  HolFacebook: "https://www.facebook.com/healthonlineuk",
  AxaPppLinkedin: "https://www.linkedin.com/company/12777",
  HolLinkedin: "https://www.linkedin.com/company/health-on-line/",
  AxaPppTwitter: "https://twitter.com/axappphealth",
  HolTwitter: "https://twitter.com/HOL_Offices",
  AxaPppYoutube: "https://www.youtube.com/channel/UCYlB5EetISMhwFRR8KK7QvA",
  AxaPppInstagram: "https://www.instagram.com/axappphealth/",

  AxaHealthFacebook: "https://facebook.com/AXAhealth",
  AxaHealthTwitter: "https://twitter.com/AXAhealth",
  AxaHealthLinkedin: "https://www.linkedin.com/company/axahealth",
  AxaHealthYoutube: "https://www.youtube.com/channel/UCYlB5EetISMhwFRR8KK7QvA",
  AxaHealthInstagram: "https://www.instagram.com/axahealth",

  HealthSupportInternational: `${Domains.AGHDomain}/en/members/your-services/`,
  FindTreatmentInternational:
    "https://www.axapppinternational.com/en/members/your-services/find-treatment/",
  InternationalSecondOpinion:
    "https://www.axapppinternational.com/en/members/your-services/second-opinion/",
  AxaDoctorAtHand: `${Domains.AxaDomain}/DAH`,
  DCATandC: "https://doctorcareanywhere.com/terms-and-conditions",
  DCATandCAXA: "https://doctorcareanywhere.com/terms-conditions-axa",
  DCAPrivacy: "https://doctorcareanywhere.com/privacy-policy",
  DCAMembersHOL: "https://doctorcareanywhere.com/holmembership/",
  DCAMembersAXA: "https://doctorcareanywhere.com/axamembership/",
  DCAMembersSignup: "https://member.doctorcareanywhere.com/SignUp/axa",
  DCAMembersBarclays: "https://member.doctorcareanywhere.com/signup/barclays",
  DCAVideoLinkAxa: "https://vimeo.com/502245953",
  ReferAFriendScheme:"https://www.axahealth.co.uk/refer-a-friend/",
  ReferABusiness:"https://www.axahealth.co.uk/small-business/sme-refer-a-business/",
  ExpNurseCounsellors:"https://www.axahealth.co.uk/personal-health/members/24-7-healthsupport/#expnursecounsellors",
  
  ActivePlusBase: `${Domains.APlusDomain}/?ignore_sso_reg=true`,
  ActivePlusPuregymTerms: `${Domains.AxaDomain}/puregymterms`,
  ActivePlusHOLPuregymTerms: `${Domains.HOLDomain}/private-health-insurance/customer-benefits/puregym-discount`,
  ActivePlusExperiences: `${Domains.APlusDomain}/experiences-landing-page?ignore_sso_reg=true`,
  ActivePlusHealthTechnology: `${Domains.APlusDomain}/health-technology-landing-page?ignore_sso_reg=true`,
  ActivePlusHealthTests: `${Domains.APlusDomain}/healthcare/health-tests?ignore_sso_reg=true`,
  ActivePlusNutrition: `${Domains.APlusDomain}/nutrition-landing?ignore_sso_reg=true`,
  ActivePlusHealthcare: `${Domains.APlusDomain}/healthcare-landing-page?ignore_sso_reg=true`,
  ActivePlusRefer: `${Domains.AxaDomain}/refer-a-friend`,
  ActivePlusSMEHealth: `${Domains.AxaDomain}/sme-health-assessment`,
  ActivePlusFitness: `${Domains.AxaDomain}/fitness-works`,
  ActivePlusClosing: `${Domains.APlusDomain}/closure-faq`,
  SMEReferrelTermsAndConditions: `${Domains.AxaDomain}/small-business/sme-referral-terms-and-conditions`,
  TakingCarePrivacy: "https://taking.care/pages/privacy-statement",
  TakingCareTermsAndCondition: "https://taking.care/pages/terms-conditions",
  TakingCare: "https://taking.care/",
  NuffieldGymTermsAndCondition : "https://www.axahealth.co.uk/terms/gym-discount/",
  NuffieldGym: "https://www.nuffieldhealth.com/axahealth/offer",
  HussleGymTermsAndCondition : "https://www.axahealth.co.uk/terms/gym-discount/",
  HussleGym: "https://www.axahealth.co.uk/fitnessoffers/",
  PhysioMoreurl:"https://www.axahealth.co.uk/personal-health/members/online-gp/",
  PhysioMoreHolurl:"https://www.axahealth.co.uk/personal-health/members/online-gp/", 
  GpSME:"https://www.axahealth.co.uk/globalassets/sme/health-hub/AH-DoctoratHand-09.23", 
  GpLarge:"https://www.axahealth.co.uk/business/products/corporate-health-insurance/workplace-online-gp/",
  MSKBannerUrl:"https://www.axahealth.co.uk/personal-health/members/muscles-bones-and-joints/",
  MonitoredPersonalAlarmSME:"https://taking.care/?utm_source=axamemberonline&utm_medium=referrral&utm_campaign=axamemberonlinesme&utm_term=40off",
  MonitoredPersonalAlarmIndividual:"https://taking.care/?utm_source=axamemberonline&utm_medium=referrral&utm_campaign=axamemberonlineindividual&utm_term=40off",
  TakingCareSME: "https://taking.care/?utm_source=axamemberonline&utm_medium=referrral&utm_campaign=axamemberonlinesme&utm_term=40off",
  TakingCareIndividual: "https://taking.care/?utm_source=axamemberonline&utm_medium=referrral&utm_campaign=axamemberonlineindividual&utm_term=40off",
  FindOutMoreAboutPersonalAlarmsSME:"https://taking.care/?utm_source=axamemberonline&utm_medium=referrral&utm_campaign=axamemberonlinesme&utm_term=40off",
  FindOutMoreAboutPersonalAlarmsIndividual:"https://taking.care/?utm_source=axamemberonline&utm_medium=referrral&utm_campaign=axamemberonlineindividual&utm_term=40off",
  TakingCareTermsAndConditionSME: "https://taking.care/pages/terms-conditions?utm_source=axamemberonline&utm_medium=referrral&utm_campaign=axamemberonlinesme&utm_term=40off",
  TakingCareTermsAndConditionIndividual:"https://taking.care/pages/terms-conditions?utm_source=axamemberonline&utm_medium=referrral&utm_campaign=axamemberonlineindividual&utm_term=40off",
  TakingCarePrivacySME: "https://taking.care/pages/privacy-statement?utm_source=axamemberonline&utm_medium=referrral&utm_campaign=axamemberonlinesme&utm_term=40off",
  TakingCarePrivacyIndividual: "https://taking.care/pages/privacy-statement?utm_source=axamemberonline&utm_medium=referrral&utm_campaign=axamemberonlineindividual&utm_term=40off",
  DentalInsurance:"https://www.axahealth.co.uk/dental-insurance/",
  AXAContactUs: `${Domains.AxaDomain}/contact-us/`,
  HOLContactUs: `${Domains.HOLDomain}/contact-us`,
  HOLDirectoryOfHospitals:"https://www.axahealth.co.uk/yourhospitallist",
  AXABeSupportedURL: "https://www.axabesupported.co.uk",
  exitSurvey: {
    MOL: "https://wh.snapsurveys.com/s.asp?k=164863155548",
    HOL: "https://online1.snapsurveys.com/oaziiv",
    international: "https://www.snapsurveys.com/wh/s.asp?k=151568641649"
  },

  ThriveInfoExternalMOL: `${Domains.AxaDomain}/thrive-mol/?referrer=mol`,
  ThriveInfoExternalHOL: `${Domains.AxaDomain}/thrive-mol/?referrer=col`,
  AXAThriveTC: `${Domains.AxaDomain}/thrive-disclaimer/`,
  AXAThriveHowDoesItWork: {
    MOL: `${Domains.AxaDomain}/thrive-guide?app=MOL`,
    HOL: `${Domains.AxaDomain}/thrive-guide?app=COL`
  },

  AXACovidInfo: `${Domains.AxaDomain}/update-on-coronavirus/`,
  AXAGlobalCovidInfo: `${Domains.AxaDomain}/en/members/coronavirus/`,
  AXABrexitInfo: `${Domains.AxaDomain}/brexit-travel/`,

  AXAUKGroup: `${Domains.AxaDomain}/group/`,
  AXASMEDAH: `${Domains.AxaDomain}/sme-dah-offer-2020/`,
  AXAWellbeingHub: `${Domains.AxaDomain}/memberlogin/`,
  AXACashBack: `${Domains.AxaDomain}/personal/member-support/how-to-make-a-cashback-claim/?referrer=MOL`,
  FaqLink : "https://www.axahealth.co.uk/memberonline-login-faqs/",
  HbsLink : "https://app.virtuallucyweb.co.uk/login/?source_url=mol-direct",
  HbsFaqs : "https://www.axahealth.co.uk/muscles-bones-joints/faq/",
  Hbsprivacypolicy:"https://www.hbsuk.co.uk/website-privacy-notice/",
  CallBackLink : "https://www.axahealth.co.uk/personal/contact-us/request-a-call-back/",
  CancerSupport : "https://www.axahealth.co.uk/private-health-insurance/cancer-care-team/",
  NeedHelpLoggingIn: "https://www.axahealth.co.uk/member-login-faqs/",
  NeedHelpMFAError:"https://www.axahealth.co.uk/mfa-sso-faqs/",
  RelayUK : "https://www.relayuk.bt.com/",
  RequestCallBack : "https://www.axahealth.co.uk/personal/contact-us/request-a-call-back/",
  EngagementPortal:{
    DV : "https://engage-web-dv.onlineapps.dv.axahealth.co.uk",
    QA : "https://engage-web-qa.onlineapps.dv.axahealth.co.uk",
    PP : "https://engage-web-pp.axahealth.co.uk",
    PR : "https://engage.axahealth.co.uk",
    DR : "https://engage-web-dr.z-ppp-pp-ase01.xpzcloud.com",
    QAEP:{
      messages: `${EPDomains.QA}/messages`,
      newmessage: `${EPDomains.QA}/messages/newmessage`,
      new: `${EPDomains.QA}/messages/new`,
      whohadtreatment: `${EPDomains.QA}/invoice/whohadtreatment`,
      preauth: `${EPDomains.QA}/treatment/beforeyoustart`,
      claimBackPayment: `${EPDomains.QA}/messages/typeofpayment`,
      uploadDoc: `${EPDomains.QA}/messages/whatdoyouneedtoupload`,
    },
    DevEP:{
      messages: `${EPDomains.Dev}/messages`,
      newmessage: `${EPDomains.Dev}/messages/newmessage`,
      new: `${EPDomains.Dev}/messages/new`,
      whohadtreatment: `${EPDomains.Dev}/invoice/whohadtreatment`,
      preauth: `${EPDomains.Dev}/treatment/beforeyoustart`,
      claimBackPayment: `${EPDomains.Dev}/messages/typeofpayment`,
      uploadDoc: `${EPDomains.Dev}/messages/whatdoyouneedtoupload`,
    },
    PPEP:{
      messages: `${EPDomains.PP}/messages`,
      newmessage: `${EPDomains.PP}/messages/newmessage`,
      new: `${EPDomains.PP}/messages/new`,
      whohadtreatment: `${EPDomains.PP}/invoice/whohadtreatment`,
      preauth: `${EPDomains.PP}/treatment/beforeyoustart`,
      claimBackPayment: `${EPDomains.PP}/messages/typeofpayment`,
      uploadDoc: `${EPDomains.PP}/messages/whatdoyouneedtoupload`,
    },
    ProdEP:{
      messages: `${EPDomains.Prod}/messages`,
      newmessage: `${EPDomains.Prod}/messages/newmessage`,
      new: `${EPDomains.Prod}/messages/new`,
      whohadtreatment: `${EPDomains.Prod}/invoice/whohadtreatment`,
      preauth: `${EPDomains.Prod}/treatment/beforeyoustart`,
      claimBackPayment: `${EPDomains.Prod}/messages/typeofpayment`,
      uploadDoc: `${EPDomains.Prod}/messages/whatdoyouneedtoupload`,
    },
    DREP:{
      messages: `${EPDomains.DR}/messages`,
      newmessage: `${EPDomains.DR}/messages/newmessage`,
      new: `${EPDomains.DR}/messages/new`,
      whohadtreatment: `${EPDomains.DR}/invoice/whohadtreatment`,
      preauth: `${EPDomains.DR}/treatment/beforeyoustart`,
      claimBackPayment: `${EPDomains.DR}/messages/typeofpayment`,
      uploadDoc: `${EPDomains.DR}/messages/whatdoyouneedtoupload`,
    }
  }
};

export const Paths = {
  AddAPlan: "/addaplan",
  AddAPlanFromNoAccess: "/addaplanfromnoaccess",
  Appointments: "/appointments",
  AppointmentDetail: "/appointmentdetail",
  AskAMedicalExpert: "/247healthsupportline",
  AuthoriseTreatment: "/authorisetreatment",
  ChangeAddress: "/changeaddress",
  ChangeBankDetails:"/changebankdetails",
  ChangePhoneNumber: "/changephonenumber",
  Check4Cancer: "/check4cancer",
  Claims: "/claims",
  ClaimDetails: "/claimdetails",
  CommunicationPreference:"/communicationneeds",
  ContactUs: "/contactus",
  Cover: "/cover",
  CoverDocuments: "/coverdocuments",
  Demo: "/demo",
  DocumentPreference: "/documentpreference",
  Error: "/error",
  FastTrack: "/Specialistappointmentbookingservice",
  GPAppointments247: "/gpappointments247",
  HealthInformation: "/healthinformation",
  HealthStore: "/healthstore",
  HealthSupport: "/healthsupport",
  HomeRoot: "/",
  HowToClaim: "/howtoclaim",
  Inbox: "/inbox",
  MessageCentre: "/messagecentre",
  InboxLoader: "/inboxloader",
  InternalView: "/internalview",
  Locked: "/locked",
  LogoutCallback: "/logoutcallback",
  LoggedOut: "/loggedout",
  MakeAClaim: "/makeaclaim",
  MakeChangesToCover: "/makechangestocover",
  MembershipInfoSaga: "/membershipdocumentssaga",
  MovedToAxaHealth: "/migratedaccount",
  MyProfile: "/myprofile",
  MyProfileContactPreferences: "/communicationsettings",
  NotFound: "/notfound",
  Permissions: "/myprofilepermissions",
  Notifications: "/notifications",
  OnlineAccessUnavailable: "/onlineaccessunavailable",
  PaymentDetails: "/paymentdetails",
  PersonConsent: "/marketingpreferences",
  HomeContactPreference: "/contactpreferences",
  HomeCommunicationPreference: "/communicationsupportoptions",
  HomeCommunicationSupportNeeds: "/communicationsupportneeds",
  PolicyLocked: "/policylocked",
  RestrictedGroup: "/restrictedgroup",
  RestrictedPolicy: "/restrictedpolicy",
  RestrictedUser: "/restricteduser",
  Renewal: "/renewal",
  StartClaim: "/startclaim",
  Thrive: "/thrive",
  Timeout: "/timeout",
  UploadInvoice: "/uploadinvoice",
  UsefulLinks: "/usefulllinks",
  ChooseYourPlan: "/chooseyourplan",
  MedicalConsent: "/medicalconsent",
  MedicalConsentConfirmation: "/medicalconsentconfirmation",
  // WorkingBody: "/workingbody",
  WorkingBody: "/musclesbonesandjoints",
  SystemUnavailable: "/systemunavailable",
  InternalViewSessionExists: "/internalviewsessionexists",
  MemberDetails: "/memberdetails",
  TimeSetting: "/timesettings",
  CancerDiagnosticServices: "/cancerdiagnosticservices",
  Check4CancerProstate: "/check4cancer/prostate",
  Check4CancerSkin: "/check4cancer/skin",
  Check4CancerBreast: "/check4cancer/breast",
  HealthHub: "/healthhub",
  MFAIncorrectAttemptErrorPage:"/toomanyincorrectMFAattempts"
};
